"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderCredits = void 0;
const SliderCredits_1 = __importDefault(require("./SliderCredits"));
exports.SliderCredits = SliderCredits_1.default;
